import { render } from "./TransferOfMoney.vue?vue&type=template&id=52cd823e&scoped=true&ts=true"
import script from "./TransferOfMoney.vue?vue&type=script&lang=ts"
export * from "./TransferOfMoney.vue?vue&type=script&lang=ts"

import "./TransferOfMoney.vue?vue&type=style&index=0&id=52cd823e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cd823e"]])

export default __exports__